//@flow
import type { ReducerState$Type } from '../genericFlowTypes'
import type { EditFormData } from './flowTypes'

export const transformDataToEditFormData=(data:any,phobos: ReducerState$Type)=>{
    let formData: EditFormData = {}
    
    const phobosResultsetData = data['phobosResultset']
    formData.isInvalidDoc = phobosResultsetData['is_invalid_doc']?phobosResultsetData['is_invalid_doc']:false
    formData.isOverrideVendorName = phobosResultsetData['is_override_vendor_name']?phobosResultsetData['is_override_vendor_name']:false
    
    if (phobosResultsetData['inv_no']){
        formData.invNo = phobosResultsetData['inv_no']
    }
    if (phobosResultsetData['inv_date']){
        formData.invDate = phobosResultsetData['inv_date']
    }
    if (phobosResultsetData['po_no']){
        formData.poNo = phobosResultsetData['po_no']
    }
    if (phobosResultsetData['service_addr']){
        formData.serviceAddr = phobosResultsetData['service_addr']
    }
    if (phobosResultsetData['total']){
        formData.total = parseFloat(phobosResultsetData['total'])
    }
    if (phobosResultsetData['vendor_name']){
        formData.vendorName = phobosResultsetData['vendor_name']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/phobos/editFormData.js